import React from "react";
import Dialog, { DialogProps } from "../../../components/Dialog";
import Button from "../../../components/Button";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { Assets } from "../../../constants/assets";
import { useAppTranslation } from "../../../i18n/useAppTranslation";
interface Props extends DialogProps {
  reward: string;
}

const DeleteDialog = (props: Props) => {
  const { t } = useAppTranslation(["barracks", "common"]);
  const [inputValue, setInputValue] = React.useState("");
  const submitKey = "DELETE";
  return (
    <Dialog {...props} noFooter title={t("barracks:dialogs.delete.title")} size="lg">
      <div className="w-100 d-flex gap-3 flex-column align-items-center justify-content-center">
        <div className="fs-md ">
          {t("barracks:dialogs.delete.message")}
          <br />
        </div>
        <div className="fs-med text-secondary">
          {t("barracks:dialogs.delete.typeToConfirm")}{" "}
        </div>
        <div className="d-flex justify-content-between dark-bg rounded-10 px-2 py-2 mb-2">
          <div>
            <input
              value={inputValue}
              placeholder={t("barracks:dialogs.delete.placeholder")}
              onChange={(e) => setInputValue(e.target.value?.toUpperCase())}
              className="dark-yellow fw-med fs-med transparent-input"
            />
          </div>
        </div>
        <div className="fs-md">
          {t("barracks:dialogs.delete.rewardIntro")} +{props.reward}{" "}
          <img src={Assets.icons.ember} width={15} />{" "}
          {t("barracks:dialogs.delete.rewardResource")}
        </div>
        <div
          style={{ marginBottom: -40 }}
          className="d-flex justify-content-between  mt-4"
        >
          <OverlayTrigger
            trigger={"hover"}
            // popperConfig={{}}
            placement="top"
            overlay={
              <Tooltip id={`tooltip-${"top"}`}>
              <small>
                  {submitKey === inputValue
                    ? t("barracks:dialogs.delete.irreversible")
                    : t("barracks:dialogs.delete.typeDelete")}
                </small>
              </Tooltip>
            }
          >
            <div>
              <Button
                loading={props.loading}
                variant="default"
                disabled={inputValue !== submitKey}
                onClick={() => {
                  props.onSubmit?.();
                  setInputValue("");
                }}
              >
                {t("barracks:dialogs.delete.delete")}
              </Button>
            </div>
          </OverlayTrigger>
          <Button
            disabled={props.loading}
            variant="primary"
            onClick={() => props.onClose?.()}
          >
            {t("common:actions.cancel")}
          </Button>
        </div>
      </div>
    </Dialog>
  );
};

export default DeleteDialog;
